module.exports = __webpack_public_path__ + "img/ione8.76f85226.png";